import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, useUitkContext, UitkContextProvider } from 'uitk-react-utils';
import styles from './uitk-form.css';
var getClassNameList = classNames.bind(styles);
var UitkGroupedFields = function (props) {
  var children = props.children,
    className = props.className,
    label = props.label,
    hasRequiredGroupFieldIndicator = props.hasRequiredGroupFieldIndicator,
    fieldSetProps = __rest(props, ["children", "className", "label", "hasRequiredGroupFieldIndicator"]);
  var baseClass = 'uitk-form-grouped-fields';
  var contextData = useUitkContext().data;
  var hasRequiredFieldIndicator = (contextData !== null && contextData !== void 0 ? contextData : {}).hasRequiredFieldIndicator;
  var wrapperClassNames = getClassNameList(baseClass, className);
  var legendClassName = getClassNameList("".concat(baseClass, "-label"));
  var legend = React.createElement("legend", {
    className: legendClassName
  }, label, hasRequiredFieldIndicator && hasRequiredGroupFieldIndicator && React.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(baseClass, "-required-asterisk")
  }, "*"));
  if (React.isValidElement(label)) {
    var labelText = React.Children.toArray(label.props.children).reduce(function (accumulator, child) {
      if (typeof child === 'string') {
        accumulator.push(child);
      } else if (typeof child === 'object') {
        accumulator.push(child.props.children);
      }
      return accumulator.join('');
    }, []);
    legend = React.cloneElement(label, {}, React.createElement("legend", {
      className: legendClassName
    }, labelText, hasRequiredFieldIndicator && hasRequiredGroupFieldIndicator && React.createElement("span", {
      "aria-hidden": "true",
      className: "".concat(baseClass, "-required-asterisk")
    }, "*")));
  }
  return React.createElement(UitkContextProvider, {
    config: {
      context: 'uitk-grouped-fields-context',
      data: {
        hasRequiredFieldIndicator: hasRequiredFieldIndicator && !hasRequiredGroupFieldIndicator
      }
    }
  }, React.createElement("fieldset", __assign({}, fieldSetProps, {
    className: wrapperClassNames
  }), legend, children));
};
UitkGroupedFields.displayName = 'UitkGroupedFields';
export { UitkGroupedFields };